module.exports = __webpack_public_path__ + "static/media/VEDL.20a6e6e9.txt";